var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:{ tggle: !_vm.internalValue, 'tggle-active': _vm.internalValue},on:{"click":function($event){_vm.internalValue = !_vm.internalValue}}},[_c('div',{staticClass:"button"})])])}
var staticRenderFns = []

export { render, staticRenderFns }